function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

export function createWorkspaceChoiceModel({ value = '', allowed = [] } = {}) {
  const choices = [...new Set(allowed.map((item) => String(item)))];
  let current = String(value || '');
  if (current && !choices.includes(current)) throw new Error('Unsupported choice.');
  return Object.freeze({
    value: () => current,
    select(next) {
      const normalized = String(next || '');
      if (!choices.includes(normalized)) throw new Error('Unsupported choice.');
      current = normalized;
      return current;
    },
  });
}

export function workspaceChoiceMarkup({ name, label, value = '', options = [] } = {}) {
  const normalizedName = String(name || '').trim();
  const normalizedOptions = options.map((option) => ({
    value: String(option?.value || ''),
    label: String(option?.label || ''),
    tone: String(option?.tone || 'neutral'),
  })).filter((option) => option.value && option.label);
  createWorkspaceChoiceModel({
    value,
    allowed: normalizedOptions.map((option) => option.value),
  });
  return `<fieldset class="workspace-choice" data-workspace-choice="${escapeHtml(normalizedName)}">
    <legend>${escapeHtml(label)}</legend>
    <input type="hidden" name="${escapeHtml(normalizedName)}" value="${escapeHtml(value)}">
    <div class="workspace-choice__options" role="radiogroup" aria-label="${escapeHtml(label)}">
      ${normalizedOptions.map((option) => `<button class="workspace-choice__option" type="button" role="radio" aria-checked="${option.value === value}" data-choice-value="${escapeHtml(option.value)}" data-tone="${escapeHtml(option.tone)}">${escapeHtml(option.label)}</button>`).join('')}
    </div>
    <small data-field-error></small>
  </fieldset>`;
}

export function mountWorkspaceChoiceControls(root) {
  if (!root?.addEventListener) return Object.freeze({ destroy() {} });
  const onClick = (event) => {
    const button = event.target.closest?.('[data-choice-value]');
    const field = button?.closest?.('[data-workspace-choice]');
    if (!button || !field || !root.contains?.(field)) return;
    const input = field.querySelector('input[type="hidden"]');
    if (!input) return;
    input.value = button.dataset.choiceValue || '';
    field.querySelectorAll('[data-choice-value]').forEach((option) => {
      option.setAttribute('aria-checked', String(option === button));
    });
    const EventClass = root.ownerDocument?.defaultView?.Event || globalThis.Event;
    input.dispatchEvent(new EventClass('input', { bubbles: true }));
    input.dispatchEvent(new EventClass('change', { bubbles: true }));
  };
  root.addEventListener('click', onClick);
  return Object.freeze({ destroy: () => root.removeEventListener('click', onClick) });
}
